// issue_comment runs the workflow YAML from the default branch, so a PR cannot
// rely on a newly-added build arg until it is merged. The disposable gate owns
// same-origin /api; keep this compatibility fallback scoped to its exact host.
const CI_E2E_PLATFORM_HOST = "ci-e2e-platform.dev.maritaca.ai";

export type ApiBaseConfig = {
    sameOriginFlag?: string;
    nodeEnv?: string;
    configuredApiBase?: string;
    hostname?: string;
};

export function resolveApiBase({
    sameOriginFlag,
    nodeEnv,
    configuredApiBase,
    hostname,
}: ApiBaseConfig) {
    const useSameOriginApi =
        sameOriginFlag?.trim() === "true" ||
        hostname === CI_E2E_PLATFORM_HOST;

    return useSameOriginApi
        ? ""
        : nodeEnv !== "development"
            ? "https://chat.maritaca.ai"
            : configuredApiBase;
}

export const API_BASE = resolveApiBase({
    sameOriginFlag: process.env.REACT_APP_USE_SAME_ORIGIN_API,
    nodeEnv: process.env.REACT_APP_NODE_ENV,
    configuredApiBase: process.env.REACT_APP_API_BASE_URL,
    hostname:
        typeof window === "undefined" ? undefined : window.location.hostname,
});

export const MONTHS_MAP: { [key: number]: string } = {
    1: "Janeiro",
    2: "Fevereiro",
    3: "Março",
    4: "Abril",
    5: "Maio",
    6: "Junho",
    7: "Julho",
    8: "Agosto",
    9: "Setembro",
    10: "Outubro",
    11: "Novembro",
    12: "Dezembro"
};

export const TOASTPROPS: { [key: string]: any } = {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "light",
}